/* The Hifz entry in the Qurʾān section: today's lesson and what's left to revise. */
import { useMemo } from 'react';
import { dayKeyIn } from '@shared/prayer';
import { useProgress, useSettings } from '@/lib/store';
import { Card } from '@/components/ui';
import { StarIcon } from '@/components/islamic/Ornaments';
import { chapter } from '@/features/quran/api';
import { dailyPages, nextLesson, reviewQueue } from './hifz';

export function HifzCard() {
  const plan = useProgress((s) => s.hifz?.main);
  const pages = useProgress((s) => s.hifzPages);
  const today = dayKeyIn(useSettings((s) => s.settings.prayer.tz));
  const learnt = useProgress((s) => s.hifzLog?.[today]?.newAyat ?? 0);
  const line = useMemo(() => {
    if (!plan || plan.deleted) return 'Memorise with a plan — 1, 2, 3 years or more';
    const q = reviewQueue(pages ?? {}, today, plan.maxReview);
    const revise = q.recent.length + q.due.length;
    const l = learnt ? null : nextLesson(plan, dailyPages(plan, today));
    const first = l?.parts[0];
    const lesson = learnt ? 'Lesson done ✓' : first ? `Today: ${chapter(first.surah).n} ${first.from}–${l!.parts.at(-1)!.to}` : 'All memorised';
    return `${lesson}${revise ? ` · ${revise} to revise` : ''}`;
  }, [plan, pages, today, learnt]);
  return (
    <Card to="/hifz" className="col-span-2 flex items-center gap-3 !p-3">
      <span className="grid h-10 w-10 place-items-center rounded-xl bg-gold/20 text-gold"><StarIcon size={21} strokeWidth={1.6} /></span>
      <span className="min-w-0 flex-1"><span className="block text-[15px] font-semibold">Hifz <span className="font-arabic font-normal text-gold">الحفظ</span></span><span className="block truncate text-[12px] text-muted">{line}</span></span>
    </Card>
  );
}
